var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceReserved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.40201,
    y: 2.40201,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    fill: "#4ABDFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.40201,
    y: 2.40201,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    stroke: "#F9F9F9",
    strokeWidth: 3.19598
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0403 18.6455L27.4423 17.8465C27.1466 17.7026 26.7791 17.8145 26.6353 18.1101C26.4835 18.4137 26.6033 18.7733 26.899 18.9171L28.1694 19.5483V23.3755L25.1731 23.3835V15.1858C25.1731 13.5878 24.1025 12.7888 22.7761 12.7888H16.3842C15.0578 12.7888 13.9872 13.5878 13.9872 15.1858V28.1695H12.7887C12.4611 28.1695 12.1895 28.4411 12.1895 28.7687C12.1895 29.0963 12.4611 29.368 12.7887 29.368H26.3716C26.6992 29.368 26.9709 29.0963 26.9709 28.7687C26.9709 28.4411 26.6992 28.1695 26.3716 28.1695H25.1731V24.582L28.7686 24.574C29.1042 24.574 29.3678 24.3023 29.3678 23.9747V19.1808C29.3678 18.9571 29.24 18.7493 29.0403 18.6455ZM15.9847 16.6959C15.9847 15.5853 16.6638 15.1858 17.4948 15.1858H21.6735C22.4965 15.1858 23.1756 15.5853 23.1756 16.6959V17.6787C23.1756 18.7813 22.4965 19.1808 21.6655 19.1808H17.4948C16.6638 19.1808 15.9847 18.7813 15.9847 17.6707V16.6959ZM16.3842 20.9785H18.7812C19.1087 20.9785 19.3804 21.2502 19.3804 21.5778C19.3804 21.9054 19.1087 22.177 18.7812 22.177H16.3842C16.0566 22.177 15.7849 21.9054 15.7849 21.5778C15.7849 21.2502 16.0566 20.9785 16.3842 20.9785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceReserved);
export default __webpack_public_path__ + "static/media/device-reserved.0e4e2817c6791f8825e48161bb463d41.svg";
export { ForwardRef as ReactComponent };